import { Box, Button, Container, Flex } from '@chakra-ui/react';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import FilterList from '@/assets/icons/ic-filter-list.svg';

import { Section } from '@/components/ui/core/Section/Section';
import { LibraryFilterDrawer } from '@/components/ui/features/hubs-conference/LibraryFilterDrawer/LibraryFilterDrawer';
import { SearchInput as SharedSearchInput } from '@/components/ui/shared/inputs/SearchInput/SearchInput';
import { DrawerState } from '@/enums/DrawerState';
import { useSearch } from '@/hooks/use-search/useSearch';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const SearchInput: FC = () => {
  const { t } = useTranslation();
  const { drawerState, change } = useQueryParams<{ drawerState: DrawerState }>({ drawerState: StringParam });

  const { getSearchInputProps } = useSearch({ scroll: true });
  const { ref, defaultValue } = getSearchInputProps();

  useEffect(() => {
    if (ref.current) {
      const queryLength = ref.current.value.length;

      ref.current.setSelectionRange(queryLength, queryLength);
      ref.current.focus();
    }
  }, []);

  function handleOnClose() {
    change({ drawerState: DrawerState.CLOSED }, { method: 'replace', shallow: true, scroll: true });
  }

  function handleOnOpen() {
    change({ drawerState: DrawerState.OPEN }, { method: 'replace', shallow: true, scroll: true });
  }

  const isDrawerOpen = drawerState === DrawerState.OPEN;

  return (
    <Section py={5} bgColor="black" position="sticky" top="63px" zIndex="dropdown">
      <LibraryFilterDrawer isOpen={isDrawerOpen} onClose={handleOnClose} />
      <Container centerContent>
        <Flex flexDir={{ base: 'column-reverse', sm: 'row' }} w="full">
          <Button
            mt={{ base: 4, sm: 0 }}
            mr={{ base: 0, sm: 4 }}
            px={{ base: 10, md: 14, lg: 16 }}
            colorScheme="white"
            variant="solid"
            size="md"
            onClick={handleOnOpen}
            rightIcon={
              <Box color="violet.500">
                <FilterList />
              </Box>
            }
          >
            {t('library.filters')}
          </Button>
          <SharedSearchInput
            w="full"
            bg="white"
            color="gray.700"
            borderRadius="full"
            placeholder={t('hubs.conference.searchPlaceholder')}
            ref={ref}
            defaultValue={defaultValue}
          />
        </Flex>
      </Container>
    </Section>
  );
};
